var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouth4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.6 35.2",
    style: {
      enableBackground: "new 0 0 66.6 35.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:#D177B8;}\n\t.st1{fill:#FF6563;}\n\t.st2{fill:#DC3F57;}\n\t.st3{fill:#842751;}\n\t.st4{fill:#FFE0EE;}\n\t.st5{opacity:0.6;fill:url(#SVGID_1_);}\n\t.st6{fill:#DD6B7C;}\n\t.st7{fill:#FFFCB8;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,24.2c0,0,10.1,10.9,17.7,10.9c9.7,0,19.9-11.3,19.9-11.3S32.2,39.9,14.3,24.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.3,5c0,0,7.3,27.4,29.6,27.4c21.8,0,29.6-27.3,29.6-27.3L33.4,18.2L3.3,5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33,10.3V5.8c0,0-5.9-1.2-13.3,0C12.3,7.1,3.3,3.5,3.3,3.5S17.1,10.9,33,10.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33,10.3C15.5,10.6,1.3,2.4,1.3,2.4S10.7,24.3,33,24.3c19.5,0,31.7-21.9,31.7-21.9S50.5,10.6,33,10.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33,10.3V5.8c0,0,5.9-1.2,13.3,0c7.4,1.2,16.4-2.3,16.4-2.3S48.9,10.9,33,10.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.8,5l2.5,6.4C9.3,11.4,19.6,23,33,23c13.4,0,23.7-12.7,23.7-12.7L59.1,5c0,0-12.5,5.9-26.2,5.9 C19.2,11,6.8,5,6.8,5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 129.6149,
    cy: 12.1516,
    r: 20.9106,
    gradientTransform: "matrix(0.8688 0 0 1 -79.728 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8,8c0,0,11.5,9.5,25,9.5C46.4,17.4,57.8,8,57.8,8l0.4-0.8c0,0-11.8,10-25.1,10C19.7,17.1,7.6,6.9,7.6,6.9L8,8 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.1,1.2c0,0,3.4,1.6,5.5,6.3c0,0,0.7-5.7-1.4-7C63-0.9,61.1,1.2,61.1,1.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M5.6,1.2c0,0-3.4,1.6-5.5,6.3c0,0-0.7-5.7,1.4-7C3.6-0.9,5.6,1.2,5.6,1.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M42.3,23.9c0,0,1.6,1.3,2.4,2.9l1.2-1.3c0,0-1.1-1.8-2.7-2.6L42.3,23.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M43.7,22.8c0,0,1.5,0.2,2.8,2.5l0.5-0.6c0,0-0.6-1.7-2.3-2.2L43.7,22.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth4);
export default __webpack_public_path__ + "static/media/Mouth4.09916c2b083acec4734612db5708d53d.svg";
export { ForwardRef as ReactComponent };